var render, staticRenderFns
import script from "./KeyboardListener.vue?vue&type=script&lang=js&"
export * from "./KeyboardListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wolf/Documents/Apps/Trading/trading-vue-bundle/trading-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280f0f2a')) {
      api.createRecord('280f0f2a', component.options)
    } else {
      api.reload('280f0f2a', component.options)
    }
    
  }
}
component.options.__file = "src/components/KeyboardListener.vue"
export default component.exports